// The cruise sim: what a flight through the solar system needs without the game
// on top. Play composes its game on this; so will explore. Only the drive and
// its frame block live here yet; the rest of cruise is still in src/main.ts.
import { createCruiseDrive, type CruiseDrive, type CruiseDriveDeps } from './drive';
import { createCruiseSystems, type CruiseSystems } from './systems';

export interface CruiseSimDeps extends CruiseDriveDeps {
  /** The game's own clocks that tick ahead of the drive each cruise frame. */
  beforeFly(dt: number): void;
}

export interface CruiseSim {
  drive: CruiseDrive;
  systems: CruiseSystems;
  dispose(): void;
}

export function createCruiseSim(deps: CruiseSimDeps): CruiseSim {
  const drive = createCruiseDrive(deps);
  const systems = createCruiseSystems({
    inFight: deps.inFight,
    beforeFly: deps.beforeFly,
    fly: drive.fly,
  });
  return { drive, systems, dispose: () => drive.dispose() };
}
